module.exports = __webpack_public_path__ + "img/img-6.d9258714.png";